<template>
	<div class="organization-modal-creator-transfer">
		<o-section
			title="Transfert du créateur"
			subtitle="Action préalable">
			<div class="role-change-wrapper">
				<p class="organization-modal-creator-transfer__description">
					<strong> Transferez le rôle de créateur </strong> à une personne de votre organisation.
					Attention toutefois, ce changement vous <span class="text--warning"> enlève les permissions et droits </span> liés au rôle de créateur.
				</p>

				<o-section subtitle="Choisissez vos rôles">
					<o-alert
						v-if="setup.hasOnlyCreatorOnCreated"
						class="mb-sm">
						Le rôle de créateur est le seul à vous être attribué, veuillez en sélectionner au moins un autre pour continuer.
					</o-alert>
					<o-alert
						v-else
						class="mb-sm">
						Sans action de votre part, vous garderez les <strong> permissions et droits liés aux rôles </strong>
						qui vous sont déjà attribués ci-dessous
					</o-alert>

					<shared-role-flat-select
						v-model="setup.userRoles"
						class="organization-modal-creator-transfer__select"
						:user="setup.self">
						<template #default>
							<div class="organization-modal-creator-transfer__select-container">
								<div
									class="organization-modal-creator-transfer__creator-crossed">
									Créateur
								</div>

								<o-chips
									v-if="setup.userRolesWithoutCreator[0]"
									class="swap-colors"
									:color="setup.swapColor(setup.userRolesWithoutCreator[0].organizationRole?.colorName)"
									outline>
									{{ setup.userRolesWithoutCreator[0].organizationRole?.name }}
									<template
										v-if="setup.userRolesWithoutCreator.length > 1"
										#dual>
										+{{ setup.userRolesWithoutCreator.length - 1 }}
									</template>
								</o-chips>
								<p
									v-else
									class="organization-modal-creator-transfer__select-label-default">
									Sélectionnez au moins un rôle
								</p>

								<o-icon icon="chevron_down"/>
							</div>
						</template>
					</shared-role-flat-select>

					<div
						v-if="!setup.userRolesWithoutCreator.length && setup.hasTriedToGoNext"
						class="organization-modal-creator-transfer__indicator">
						<o-icon font-icon="icon-interface-alert-warning-triangle"/>
						<p>Vous devez avoir au moins un rôle pour poursuivre</p>
					</div>
				</o-section>

				<!-- <o-alert
					color="warning"
					center>
					Vous perdrez vos droits liés au rôle de <b>Créateur</b> suite au transfert.
					Vérifiez bien vos autres rôles qui eux, seront conservés.
				</o-alert>

				<div class="role-selector">
					<strong>Vérifier vos rôles :</strong>
					<role-flat-select
						v-model="userRoles"
						:user="$self"
						@click.native.stop/>
				</div>

				<o-alert
					v-if="!userRolesWithoutCreator.length"
					color="danger"
					center>
					Vous devez vous attribuer au moins un rôle.
				</o-alert> -->
			</div>
		</o-section>

		<o-section class="organization-modal-creator-transfer__actions">
			<o-button
				block
				:color="!setup.userRolesWithoutCreator.length ? 'default' : 'info'"
				:disabled="!setup.userRolesWithoutCreator.length"
				:outline="!setup.userRolesWithoutCreator.length"
				@click="setup.defineNewCreator()">
				Sélectionner le nouveau créateur
			</o-button>
			<o-button
				color="danger"
				nude
				block
				@click="_modal?.close()">
				Annuler
			</o-button>
		</o-section>
	</div>
</template>

<script setup lang="ts">
import OrganizationModalCreatorTransferSetupService from '@/setup/organization/OrganizationModalCreatorTransferSetupService';
import { inject } from 'vue';
const _modal = inject<OrionModal>('_modal');
const props = defineProps(OrganizationModalCreatorTransferSetupService.props);
const setup = new OrganizationModalCreatorTransferSetupService(props);
</script>

<style scoped lang="less">
@import '@/styles/variables.less';
@import '@/styles/mixins.less';

.organization-modal-creator-transfer {
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	&__description {
		color: var(--grey-dark);
		margin-bottom: 2rem;
	}

	&__select {
		min-width: 100%;
		.trigger {
			width: 100%;
		}
	}

	&__select-container {
		position: relative;
		display: flex;
		align-items: center;
		gap: 0.5rem;
		border-radius: 0.25rem;
		border: 1px solid var(--grey-light);
    padding-right: 2.5rem;

		.orion-icon {
			position: absolute;
			right: 0.75rem;
			font-size: 1rem;
			color: var(--grey-dark);
		}

    :deep(.orion-chips__main) {
      .ellipsis();
    }
	}

	&__select-label-default {
		color: var(--grey);
		line-height: 25px;
		margin: unset;
		margin-left: 5px;
	}

	&__creator-crossed {
		font-weight: 600;
		text-decoration: line-through;
		padding: 10px 15px;
		background: var(--grey-lighter);
		border-radius: 5px 0 0 5px;
	}

	&__indicator {
		font-size: 13px;
		display: flex;
		align-items: center;
		gap: 10px;
		padding-left: 5px;
		margin-top: 15px;
		color: var(--warning);

		p {
			margin: unset;
		}
	}

	&__actions {
		.orion-button {
			+ .orion-button {
				margin-top: 10px;
			}
		}
	}

	&__btn{
		&--disabled {
			background: rgba(--rgb-grey-light, 0.6) !important;
			color: var(--grey) !important;
			box-shadow: unset !important;
		}
	}
}
</style>
